// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"60":"1c160317","236":"8d5c1730","280":"0cc4f8e3","359":"8081ad8f","444":"420adf13"}[chunkId] + ".js";
};